// profile/actions.ts
import {ActionTree} from 'vuex';
import {ReviewRate, CommentQue, RateState, FAQ} from './types';
import {RootState} from '@/store/types';
import Vue from 'vue';
import * as firebase from 'firebase/app';
import DocumentSnapshot = firebase.firestore.DocumentSnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import * as _ from 'lodash';

/* tslint:disable:no-console */

export const actions: ActionTree<RateState, RootState> = {
    async upsertReview({commit, state}, {body, uid}): Promise<any> {
        return await Vue.prototype.$firestore.collection('reviews').doc(uid).set(body, {merge: true});
    },
    async addComment({commit, state}, body ): Promise<any> {
      return   await Vue.prototype.$firestore.collection('comments').add(body);
    },
    getReviews({ state, commit }) {
        Vue.prototype.$firestore.collection(`reviews`).onSnapshot(async (snapshot: QuerySnapshot) => {
            const rev: ReviewRate[] = [];
            const done = _.after(snapshot.docs.length, () => {
                commit('setReviews', rev);
            });
            _.forEach(snapshot.docs, (document: QueryDocumentSnapshot) => {
                const vio: ReviewRate = new ReviewRate(document.data());
                vio.getUser().then(() => {
                    rev.push(vio);
                    done();
                });

            });
        }, (error: any) => {
            if (Vue.prototype.$auth.currentUser !== null) {
                console.log(`Error getting reviews: ${error}`);
            }
        });
    },
    getComments({ state, commit }) {
        Vue.prototype.$firestore.collection(`comments`).onSnapshot(async (snapshot: QuerySnapshot) => {
            const rev: CommentQue[] = [];
            const done = _.after(snapshot.docs.length, () => {
                commit('setComments', rev);
            });
            _.forEach(snapshot.docs, (document: QueryDocumentSnapshot) => {
                const com: CommentQue  = new CommentQue(document.data());
                com.getUser().then(() => {
                    com.setDocumentReference(document.ref);
                    rev.push(com);
                    done();
                });

            });
        }, (error: any) => {
            if (Vue.prototype.$auth.currentUser !== null) {
                console.log(`Error getting comments: ${error}`);
            }
        });
    },
    getFAQs({commit}) {
        Vue.prototype.$firestore.collection('lookups').doc('faq').onSnapshot((snapshot: DocumentSnapshot) => {
            commit('setFAQ', FAQ.returnFAQList(snapshot));
        }, (error: any) => {
            if (Vue.prototype.$auth.currentUser !== null) {
                console.log(`Error getting FAQs: ${error}`);
            }
        });
    },
    /* tslint:disable:no-console */
    async updateMAFComment({ state, commit }, comment: CommentQue): Promise<any> {
        if (comment.Reference) {
            try {
                // update FireStore document reference
                return await comment.Reference.update(comment.toPlainObj());
            } catch (error) {
                console.log(error);
                return error;
            }
        } else {
            console.error('Comment does not have reference object');
        }
    },

};
